module.exports = require("./fr.d.ts");